import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { changeRequestApiClient } from '@/clients/ChangeRequestAPIClient';
import { IChangeRequest } from '@/data/models/changeRequest';

export default function useGetActiveChangeRequestQuery(
  albumId: string
): UseQueryResult<IChangeRequest, Error> {
  async function queryFn() {
    const response =
      await changeRequestApiClient.getActiveChangeRequest(albumId);
    return response.data;
  }

  return useQuery({
    queryFn,
    queryKey: ['changeRequestAlbum', albumId],
    staleTime: 10000,
  });
}
